import { AsyncStoreItem } from '@lib/store';
import { JuniorPilotGetReceiptResponse } from 'src/sdk-servicing';

/**
 * GetReceiptJuniorPilot model
 */
export interface GetReceiptJuniorPilotModel {
  model: JuniorPilotGetReceiptResponse | null;
}

/**
 * JuniorPilotGetReceiptResponse model details
 */
export interface GetReceiptJuniorPilotStateDetails extends AsyncStoreItem {}

/**
 * GetReceiptJuniorPilot store state
 */
export interface GetReceiptJuniorPilotState extends GetReceiptJuniorPilotStateDetails, GetReceiptJuniorPilotModel {}

/**
 * Name of the GetReceiptJuniorPilot Store
 */
export const GET_RECEIPT_JUNIOR_PILOT_STORE_NAME = 'getReceiptJuniorPilot';

/**
 * GetReceiptJuniorPilot Store Interface
 */
export interface GetReceiptJuniorPilotStore {
  /** GetReceiptJuniorPilot state */
  [GET_RECEIPT_JUNIOR_PILOT_STORE_NAME]: GetReceiptJuniorPilotState;
}
